<template>
  <v-container fluid class="navbar--padding background">
    <v-container>
      <v-row class="my-auto">
        <v-col class="py-15" sm="8" cols="12">
          <v-img
            :class="{ hidden: isScrolled }"
            alt="Central lab logo"
            class="shrink mb-10"
            contain
            src="../../assets/png/Logo_White.png"
            :width="isMobile ? '75%' : '50%'"
          />
          <span class="hero"> {{ header.title }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.local"
          class="my-0"
          md="4"
          sm="4"
          cols="12"
        >
          <HeaderCard :card="card" />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import HeaderCard from "./HeaderCard.vue";
import lang from "../../lang/pt.json";

export default {
  name: "Header",

  components: {
    HeaderCard,
  },

  props: {
    scroll: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    header: lang.home.header,
    cards: lang.home.cards,
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isScrolled() {
      return this.scroll !== 0;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.background {
  // background-image: url("../../assets/svg/BG_Landing.svg");
  // background-repeat: no-repeat;
  // background-size: 100%;
  // background-position: cover;
  background: map-get($theme-colors, "backgroundpartnership");
}

.hero {
  font-size: 50px;
  font-family: nexa_regular;
  color: white;
  letter-spacing: 0;
  line-height: 72px;
}

.navbar--padding {
  padding-top: 92px;
}

.hidden {
  visibility: hidden !important;
}
</style>
